import { request } from './request'

export const getList = (data) => {
  const url = '/ocean/api/v1/product/category/page'
  return request({
    method: 'post',
    url: url,
    data
  })
}
export const addListItem = (data) => {
  const url = '/ocean/api/v1/product/category/saveOrUpdate'
  return request({
    method: 'put',
    url: url,
    data: data
  })
}

export const deleteListItem = (data) => {
  const url = `/ocean/api/v1/product/category/delete/${data.id}`
  return request({
    method: 'delete',
    url: url
  })
}

export const initCate = data => {
  return request({
    method: 'POST',
    url: '/ocean/api/v1/product/category/initProductCategory',
    params: data
  })
}
